import React from 'react';
import Modal from './Modal';
import { ValidationError } from '../utils/profileValidation';

interface ValidationErrorsModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors: ValidationError[];
  onClearAndSave: () => void;
}

const ValidationErrorsModal: React.FC<ValidationErrorsModalProps> = ({
  isOpen,
  onClose,
  errors,
  onClearAndSave
}) => {
  // Agrupar errores por pestaña
  const errorsByTab = errors.reduce((acc, error) => {
    const key = error.tab;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(error);
    return acc;
  }, {} as Record<string, ValidationError[]>);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClearAndSave}
      confirmText="Vaciar campos inválidos y guardar"
      cancelText="Cancelar"
    >
      <p style={{ marginBottom: '12px' }}>
        Se encontraron {errors.length} campo{errors.length !== 1 ? 's' : ''} con datos inválidos en:
      </p>
      <ul style={{ marginBottom: '12px', paddingLeft: '20px' }}>
        {Object.entries(errorsByTab).map(([tab, tabErrors]) => (
          <li key={tab} style={{ marginBottom: '8px' }}>
            <strong>{tab}</strong>
            <ul style={{ marginTop: '4px', paddingLeft: '20px' }}>
              {tabErrors.map((error, index) => (
                <li key={`${error.field}-${index}`} style={{ marginBottom: '4px' }}>
                  {error.label}
                  {error.subTab && ` (${error.subTab})`}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      <p style={{ marginTop: '12px' }}>
        Puedes cancelar para corregir los campos o vaciar los campos inválidos y guardar el perfil.
      </p>
    </Modal>
  );
};

export default ValidationErrorsModal;
